<img src="../../../../assets/images/SPACE AR small.png" style="width:100px;margin-left:20px;"/>


<div style="margin-top:10px;"><span style="margin-left:20px;font-size:18px;font-weight: bold;;">Amano One Matching Card Number Found</span></div>
<div>

    <div style="margin-top:20px;margin-left:20px;margin-bottom:15px;">
       Card Number <span style="font-weight:bold;color:red;">{{accessHolder.credentials[0].credentialReference}}</span> already exists in the Amano One PARCS system.  Please review the information below and click Overwrite to update the Parker information in the Amano One profile.
    </div>

    <div class="row" style="margin-left:20px;margin-right:20px;">
        <div class="col-4" >{{accessHolder.contactInfo.lastName}}, {{accessHolder.contactInfo.firstName}}</div>

        @if(accessHolder.contactInfo.emails.length > 0) {
        <div class="col-4">{{accessHolder.contactInfo.emails[0].emailAddress}}</div>
          @if(accessHolder.company != null ||  accessHolder.company != '') {
            <div class="col-4">{{accessHolder.company}}x</div>}
          @else{
            <div class="col-4">No Company on File </div>
          }
        } @else {
        <div class="col-4">No Email on File</div>
          @if(accessHolder.company === null || accessHolder.company === '') {
            <div class="col-4">No Company on File </div>
          }
          @else{
            <div class="col-4">{{accessHolder.company}}</div>
          }
        }

        
        <div class="col-4">Start Date: {{accessHolder.startDate | date}}</div>
        <div class="col-4">End Date: {{accessHolder.endDate | date}}</div>
        <div class="col-4"></div>

        @if(accessHolder.vehicles.length > 0) {
          <div class="col-4">{{accessHolder.vehicles[0].vehicleYear}} {{accessHolder.vehicles[0].make}}</div>
          <div class="col-4">{{accessHolder.vehicles[0].model}}</div>
          <div class="col-4">License: {{accessHolder.vehicles[0].licenseNumber}}</div>
        }
        @else {
          <div class="col-6">No Vehicle(s) on File</div>
          <div class="col-6"></div>
        }
        
    </div>
    
</div>
<img src="../../../../assets/icons/yellow-warning-triangle.png" style="height:30px;width:30px;margin-left:15px;top:40px;position:relative;">
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false" >Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial style="background-color:#003087 !important;color:white !important">Overwrite</button>
</div>

